/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './SensitiveDataStatusControllerFrontendService';
import * as Queries from './SensitiveDataStatusControllerFrontendService.dfc.new';
import type { AdditionalContextArgs } from './SensitiveDataStatusControllerFrontendService.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseEnableSensitiveDataAsyncMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.EnableSensitiveDataAsyncResponseType>,
    References.EnableSensitiveDataAsyncRequestType,
    T extends true
      ? Record<
          'enableSensitiveDataAsync',
          References.EnableSensitiveDataAsyncResponseType
        >
      : References.EnableSensitiveDataAsyncResponseType
  >;

export function useEnableSensitiveDataAsyncMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.EnableSensitiveDataAsyncResponseType>,
    References.EnableSensitiveDataAsyncRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseEnableSensitiveDataAsyncMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.ENABLE_SENSITIVE_DATA_ASYNC_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            enableSensitiveDataAsync: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseEnableSensitiveDataAsyncMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseEnableSensitiveDataAsyncMutationReturn<T>;
}

type UseDisableSensitiveDataAsyncMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.DisableSensitiveDataAsyncResponseType>,
    {},
    T extends true
      ? Record<
          'disableSensitiveDataAsync',
          References.DisableSensitiveDataAsyncResponseType
        >
      : References.DisableSensitiveDataAsyncResponseType
  >;

export function useDisableSensitiveDataAsyncMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DisableSensitiveDataAsyncResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDisableSensitiveDataAsyncMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DISABLE_SENSITIVE_DATA_ASYNC_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            disableSensitiveDataAsync: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDisableSensitiveDataAsyncMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDisableSensitiveDataAsyncMutationReturn<T>;
}

type UseGetSensitiveDataOnboardingOrEnabledQueryReturn<T extends boolean> =
  Omit<
    QueryResult<
      Record<
        'result',
        References.GetSensitiveDataOnboardingOrEnabledResponseType
      >
    >,
    'data'
  > & {
    data:
      | (T extends true
          ? Record<
              'getSensitiveDataOnboardingOrEnabled',
              References.GetSensitiveDataOnboardingOrEnabledResponseType
            >
          : References.GetSensitiveDataOnboardingOrEnabledResponseType)
      | undefined;
  };

export function useGetSensitiveDataOnboardingOrEnabledQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetSensitiveDataOnboardingOrEnabledResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataOnboardingOrEnabledQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SENSITIVE_DATA_ONBOARDING_OR_ENABLED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataOnboardingOrEnabled: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSensitiveDataOnboardingOrEnabledQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSensitiveDataOnboardingOrEnabledQueryReturn<T>;
}

type UseGetSensitiveDataOnboardingOrEnabledLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<
      'result',
      References.GetSensitiveDataOnboardingOrEnabledResponseType
    >,
    {},
    T extends true
      ? Record<
          'getSensitiveDataOnboardingOrEnabled',
          References.GetSensitiveDataOnboardingOrEnabledResponseType
        >
      : References.GetSensitiveDataOnboardingOrEnabledResponseType
  >;

export function useGetSensitiveDataOnboardingOrEnabledLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSensitiveDataOnboardingOrEnabledResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataOnboardingOrEnabledLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SENSITIVE_DATA_ONBOARDING_OR_ENABLED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataOnboardingOrEnabled: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSensitiveDataOnboardingOrEnabledLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSensitiveDataOnboardingOrEnabledLazyQueryReturn<T>;
}

type UseGetSensitiveDataOnboardingOrEnabledSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetSensitiveDataOnboardingOrEnabledResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getSensitiveDataOnboardingOrEnabled',
        References.GetSensitiveDataOnboardingOrEnabledResponseType
      >
    : References.GetSensitiveDataOnboardingOrEnabledResponseType;
};

export function useGetSensitiveDataOnboardingOrEnabledSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSensitiveDataOnboardingOrEnabledResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataOnboardingOrEnabledSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SENSITIVE_DATA_ONBOARDING_OR_ENABLED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataOnboardingOrEnabled: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSensitiveDataOnboardingOrEnabledSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSensitiveDataOnboardingOrEnabledSuspenseQueryReturn<T>;
}

type UseGetSensitiveDataSubsettingsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetSensitiveDataSubsettingsResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getSensitiveDataSubsettings',
            References.GetSensitiveDataSubsettingsResponseType
          >
        : References.GetSensitiveDataSubsettingsResponseType)
    | undefined;
};

export function useGetSensitiveDataSubsettingsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSensitiveDataSubsettingsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataSubsettingsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SENSITIVE_DATA_SUBSETTINGS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataSubsettings: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSensitiveDataSubsettingsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSensitiveDataSubsettingsQueryReturn<T>;
}

type UseGetSensitiveDataSubsettingsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSensitiveDataSubsettingsResponseType>,
    {},
    T extends true
      ? Record<
          'getSensitiveDataSubsettings',
          References.GetSensitiveDataSubsettingsResponseType
        >
      : References.GetSensitiveDataSubsettingsResponseType
  >;

export function useGetSensitiveDataSubsettingsLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSensitiveDataSubsettingsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataSubsettingsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SENSITIVE_DATA_SUBSETTINGS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataSubsettings: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSensitiveDataSubsettingsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSensitiveDataSubsettingsLazyQueryReturn<T>;
}

type UseGetSensitiveDataSubsettingsSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetSensitiveDataSubsettingsResponseType>
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getSensitiveDataSubsettings',
          References.GetSensitiveDataSubsettingsResponseType
        >
      : References.GetSensitiveDataSubsettingsResponseType;
  };

export function useGetSensitiveDataSubsettingsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSensitiveDataSubsettingsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataSubsettingsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SENSITIVE_DATA_SUBSETTINGS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataSubsettings: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSensitiveDataSubsettingsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSensitiveDataSubsettingsSuspenseQueryReturn<T>;
}

type UseGetHipaaEnabledForPortalQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetHipaaEnabledForPortalResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getHipaaEnabledForPortal',
            References.GetHipaaEnabledForPortalResponseType
          >
        : References.GetHipaaEnabledForPortalResponseType)
    | undefined;
};

export function useGetHipaaEnabledForPortalQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetHipaaEnabledForPortalResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetHipaaEnabledForPortalQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_HIPAA_ENABLED_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getHipaaEnabledForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetHipaaEnabledForPortalQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetHipaaEnabledForPortalQueryReturn<T>;
}

type UseGetHipaaEnabledForPortalLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetHipaaEnabledForPortalResponseType>,
    {},
    T extends true
      ? Record<
          'getHipaaEnabledForPortal',
          References.GetHipaaEnabledForPortalResponseType
        >
      : References.GetHipaaEnabledForPortalResponseType
  >;

export function useGetHipaaEnabledForPortalLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetHipaaEnabledForPortalResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetHipaaEnabledForPortalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_HIPAA_ENABLED_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getHipaaEnabledForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetHipaaEnabledForPortalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetHipaaEnabledForPortalLazyQueryReturn<T>;
}

type UseGetHipaaEnabledForPortalSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetHipaaEnabledForPortalResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getHipaaEnabledForPortal',
        References.GetHipaaEnabledForPortalResponseType
      >
    : References.GetHipaaEnabledForPortalResponseType;
};

export function useGetHipaaEnabledForPortalSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetHipaaEnabledForPortalResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetHipaaEnabledForPortalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_HIPAA_ENABLED_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getHipaaEnabledForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetHipaaEnabledForPortalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetHipaaEnabledForPortalSuspenseQueryReturn<T>;
}

type UseUpdateSubsettingsAsyncMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateSubsettingsAsyncResponseType>,
    References.UpdateSubsettingsAsyncRequestType,
    T extends true
      ? Record<
          'updateSubsettingsAsync',
          References.UpdateSubsettingsAsyncResponseType
        >
      : References.UpdateSubsettingsAsyncResponseType
  >;

export function useUpdateSubsettingsAsyncMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateSubsettingsAsyncResponseType>,
    References.UpdateSubsettingsAsyncRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateSubsettingsAsyncMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_SUBSETTINGS_ASYNC_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateSubsettingsAsync: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateSubsettingsAsyncMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateSubsettingsAsyncMutationReturn<T>;
}

type UseGetSensitiveDataStateAndSubsettingsForPortalQueryReturn<
  T extends boolean,
> = Omit<
  QueryResult<
    Record<
      'result',
      References.GetSensitiveDataStateAndSubsettingsForPortalResponseType
    >
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getSensitiveDataStateAndSubsettingsForPortal',
            References.GetSensitiveDataStateAndSubsettingsForPortalResponseType
          >
        : References.GetSensitiveDataStateAndSubsettingsForPortalResponseType)
    | undefined;
};

export function useGetSensitiveDataStateAndSubsettingsForPortalQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<
      'result',
      References.GetSensitiveDataStateAndSubsettingsForPortalResponseType
    >
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataStateAndSubsettingsForPortalQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SENSITIVE_DATA_STATE_AND_SUBSETTINGS_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataStateAndSubsettingsForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSensitiveDataStateAndSubsettingsForPortalQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSensitiveDataStateAndSubsettingsForPortalQueryReturn<T>;
}

type UseGetSensitiveDataStateAndSubsettingsForPortalLazyQueryReturn<
  T extends boolean,
> = LazyQueryResultTupleOverride<
  Record<
    'result',
    References.GetSensitiveDataStateAndSubsettingsForPortalResponseType
  >,
  {},
  T extends true
    ? Record<
        'getSensitiveDataStateAndSubsettingsForPortal',
        References.GetSensitiveDataStateAndSubsettingsForPortalResponseType
      >
    : References.GetSensitiveDataStateAndSubsettingsForPortalResponseType
>;

export function useGetSensitiveDataStateAndSubsettingsForPortalLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<
      'result',
      References.GetSensitiveDataStateAndSubsettingsForPortalResponseType
    >
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataStateAndSubsettingsForPortalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SENSITIVE_DATA_STATE_AND_SUBSETTINGS_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataStateAndSubsettingsForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSensitiveDataStateAndSubsettingsForPortalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSensitiveDataStateAndSubsettingsForPortalLazyQueryReturn<T>;
}

type UseGetSensitiveDataStateAndSubsettingsForPortalSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<
      'result',
      References.GetSensitiveDataStateAndSubsettingsForPortalResponseType
    >
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getSensitiveDataStateAndSubsettingsForPortal',
        References.GetSensitiveDataStateAndSubsettingsForPortalResponseType
      >
    : References.GetSensitiveDataStateAndSubsettingsForPortalResponseType;
};

export function useGetSensitiveDataStateAndSubsettingsForPortalSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<
      'result',
      References.GetSensitiveDataStateAndSubsettingsForPortalResponseType
    >
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataStateAndSubsettingsForPortalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SENSITIVE_DATA_STATE_AND_SUBSETTINGS_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataStateAndSubsettingsForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSensitiveDataStateAndSubsettingsForPortalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSensitiveDataStateAndSubsettingsForPortalSuspenseQueryReturn<T>;
}

type UseGetSensitiveDataStateForPortalQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetSensitiveDataStateForPortalResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getSensitiveDataStateForPortal',
            References.GetSensitiveDataStateForPortalResponseType
          >
        : References.GetSensitiveDataStateForPortalResponseType)
    | undefined;
};

export function useGetSensitiveDataStateForPortalQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetSensitiveDataStateForPortalResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataStateForPortalQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SENSITIVE_DATA_STATE_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataStateForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSensitiveDataStateForPortalQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSensitiveDataStateForPortalQueryReturn<T>;
}

type UseGetSensitiveDataStateForPortalLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSensitiveDataStateForPortalResponseType>,
    {},
    T extends true
      ? Record<
          'getSensitiveDataStateForPortal',
          References.GetSensitiveDataStateForPortalResponseType
        >
      : References.GetSensitiveDataStateForPortalResponseType
  >;

export function useGetSensitiveDataStateForPortalLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSensitiveDataStateForPortalResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataStateForPortalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SENSITIVE_DATA_STATE_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataStateForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSensitiveDataStateForPortalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSensitiveDataStateForPortalLazyQueryReturn<T>;
}

type UseGetSensitiveDataStateForPortalSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetSensitiveDataStateForPortalResponseType>
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getSensitiveDataStateForPortal',
          References.GetSensitiveDataStateForPortalResponseType
        >
      : References.GetSensitiveDataStateForPortalResponseType;
  };

export function useGetSensitiveDataStateForPortalSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSensitiveDataStateForPortalResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSensitiveDataStateForPortalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SENSITIVE_DATA_STATE_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSensitiveDataStateForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSensitiveDataStateForPortalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSensitiveDataStateForPortalSuspenseQueryReturn<T>;
}

type UseGetPortalDisablementPermittedQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetPortalDisablementPermittedResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getPortalDisablementPermitted',
            References.GetPortalDisablementPermittedResponseType
          >
        : References.GetPortalDisablementPermittedResponseType)
    | undefined;
};

export function useGetPortalDisablementPermittedQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetPortalDisablementPermittedResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPortalDisablementPermittedQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_PORTAL_DISABLEMENT_PERMITTED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPortalDisablementPermitted: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPortalDisablementPermittedQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPortalDisablementPermittedQueryReturn<T>;
}

type UseGetPortalDisablementPermittedLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetPortalDisablementPermittedResponseType>,
    {},
    T extends true
      ? Record<
          'getPortalDisablementPermitted',
          References.GetPortalDisablementPermittedResponseType
        >
      : References.GetPortalDisablementPermittedResponseType
  >;

export function useGetPortalDisablementPermittedLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetPortalDisablementPermittedResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPortalDisablementPermittedLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_PORTAL_DISABLEMENT_PERMITTED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPortalDisablementPermitted: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetPortalDisablementPermittedLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetPortalDisablementPermittedLazyQueryReturn<T>;
}

type UseGetPortalDisablementPermittedSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetPortalDisablementPermittedResponseType>
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getPortalDisablementPermitted',
          References.GetPortalDisablementPermittedResponseType
        >
      : References.GetPortalDisablementPermittedResponseType;
  };

export function useGetPortalDisablementPermittedSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetPortalDisablementPermittedResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPortalDisablementPermittedSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_PORTAL_DISABLEMENT_PERMITTED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getPortalDisablementPermitted: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPortalDisablementPermittedSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPortalDisablementPermittedSuspenseQueryReturn<T>;
}

type UseGetPortalEligibilityForSensitiveDataQueryReturn<T extends boolean> =
  Omit<
    QueryResult<
      Record<
        'result',
        References.GetPortalEligibilityForSensitiveDataResponseType
      >
    >,
    'data'
  > & {
    data:
      | (T extends true
          ? Record<
              'getPortalEligibilityForSensitiveData',
              References.GetPortalEligibilityForSensitiveDataResponseType
            >
          : References.GetPortalEligibilityForSensitiveDataResponseType)
      | undefined;
  };

export function useGetPortalEligibilityForSensitiveDataQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<
      'result',
      References.GetPortalEligibilityForSensitiveDataResponseType
    >
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPortalEligibilityForSensitiveDataQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_PORTAL_ELIGIBILITY_FOR_SENSITIVE_DATA_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPortalEligibilityForSensitiveData: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPortalEligibilityForSensitiveDataQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPortalEligibilityForSensitiveDataQueryReturn<T>;
}

type UseGetPortalEligibilityForSensitiveDataLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<
      'result',
      References.GetPortalEligibilityForSensitiveDataResponseType
    >,
    {},
    T extends true
      ? Record<
          'getPortalEligibilityForSensitiveData',
          References.GetPortalEligibilityForSensitiveDataResponseType
        >
      : References.GetPortalEligibilityForSensitiveDataResponseType
  >;

export function useGetPortalEligibilityForSensitiveDataLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<
      'result',
      References.GetPortalEligibilityForSensitiveDataResponseType
    >
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPortalEligibilityForSensitiveDataLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_PORTAL_ELIGIBILITY_FOR_SENSITIVE_DATA_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPortalEligibilityForSensitiveData: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetPortalEligibilityForSensitiveDataLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetPortalEligibilityForSensitiveDataLazyQueryReturn<T>;
}

type UseGetPortalEligibilityForSensitiveDataSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<
      'result',
      References.GetPortalEligibilityForSensitiveDataResponseType
    >
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getPortalEligibilityForSensitiveData',
        References.GetPortalEligibilityForSensitiveDataResponseType
      >
    : References.GetPortalEligibilityForSensitiveDataResponseType;
};

export function useGetPortalEligibilityForSensitiveDataSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<
      'result',
      References.GetPortalEligibilityForSensitiveDataResponseType
    >
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPortalEligibilityForSensitiveDataSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_PORTAL_ELIGIBILITY_FOR_SENSITIVE_DATA_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getPortalEligibilityForSensitiveData: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPortalEligibilityForSensitiveDataSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPortalEligibilityForSensitiveDataSuspenseQueryReturn<T>;
}

type UseGetMaskingOptInQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetMaskingOptInResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getMaskingOptIn', References.GetMaskingOptInResponseType>
        : References.GetMaskingOptInResponseType)
    | undefined;
};

export function useGetMaskingOptInQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetMaskingOptInResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMaskingOptInQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_MASKING_OPT_IN_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMaskingOptIn: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMaskingOptInQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetMaskingOptInQueryReturn<T>;
}

type UseGetMaskingOptInLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetMaskingOptInResponseType>,
    {},
    T extends true
      ? Record<'getMaskingOptIn', References.GetMaskingOptInResponseType>
      : References.GetMaskingOptInResponseType
  >;

export function useGetMaskingOptInLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetMaskingOptInResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMaskingOptInLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_MASKING_OPT_IN_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMaskingOptIn: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetMaskingOptInLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetMaskingOptInLazyQueryReturn<T>;
}

type UseGetMaskingOptInSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetMaskingOptInResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getMaskingOptIn', References.GetMaskingOptInResponseType>
    : References.GetMaskingOptInResponseType;
};

export function useGetMaskingOptInSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetMaskingOptInResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMaskingOptInSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_MASKING_OPT_IN_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getMaskingOptIn: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMaskingOptInSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMaskingOptInSuspenseQueryReturn<T>;
}

type UseSetMaskingOptInMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SetMaskingOptInResponseType>,
    References.SetMaskingOptInRequestType,
    T extends true
      ? Record<'setMaskingOptIn', References.SetMaskingOptInResponseType>
      : References.SetMaskingOptInResponseType
  >;

export function useSetMaskingOptInMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SetMaskingOptInResponseType>,
    References.SetMaskingOptInRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSetMaskingOptInMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SET_MASKING_OPT_IN_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            setMaskingOptIn: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSetMaskingOptInMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSetMaskingOptInMutationReturn<T>;
}

type UseGetBreezeAccessOptInsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetBreezeAccessOptInsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getBreezeAccessOptIns',
            References.GetBreezeAccessOptInsResponseType
          >
        : References.GetBreezeAccessOptInsResponseType)
    | undefined;
};

export function useGetBreezeAccessOptInsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetBreezeAccessOptInsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBreezeAccessOptInsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_BREEZE_ACCESS_OPT_INS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getBreezeAccessOptIns: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetBreezeAccessOptInsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetBreezeAccessOptInsQueryReturn<T>;
}

type UseGetBreezeAccessOptInsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetBreezeAccessOptInsResponseType>,
    {},
    T extends true
      ? Record<
          'getBreezeAccessOptIns',
          References.GetBreezeAccessOptInsResponseType
        >
      : References.GetBreezeAccessOptInsResponseType
  >;

export function useGetBreezeAccessOptInsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetBreezeAccessOptInsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBreezeAccessOptInsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BREEZE_ACCESS_OPT_INS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getBreezeAccessOptIns: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetBreezeAccessOptInsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetBreezeAccessOptInsLazyQueryReturn<T>;
}

type UseGetBreezeAccessOptInsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetBreezeAccessOptInsResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getBreezeAccessOptIns',
        References.GetBreezeAccessOptInsResponseType
      >
    : References.GetBreezeAccessOptInsResponseType;
};

export function useGetBreezeAccessOptInsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetBreezeAccessOptInsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBreezeAccessOptInsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_BREEZE_ACCESS_OPT_INS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getBreezeAccessOptIns: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetBreezeAccessOptInsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetBreezeAccessOptInsSuspenseQueryReturn<T>;
}

type UseSetBreezeAccessOptInMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SetBreezeAccessOptInResponseType>,
    References.SetBreezeAccessOptInRequestType,
    T extends true
      ? Record<
          'setBreezeAccessOptIn',
          References.SetBreezeAccessOptInResponseType
        >
      : References.SetBreezeAccessOptInResponseType
  >;

export function useSetBreezeAccessOptInMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SetBreezeAccessOptInResponseType>,
    References.SetBreezeAccessOptInRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSetBreezeAccessOptInMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SET_BREEZE_ACCESS_OPT_IN_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            setBreezeAccessOptIn: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSetBreezeAccessOptInMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSetBreezeAccessOptInMutationReturn<T>;
}
